<template>
  <div class="card-carousel">
    <swiper
      ref="mySwiper"
      :options="swiperOptions"
      class="swiper"
    >
      <swiper-slide
        v-for="(item, index) in questionList"
        :key="index"
        class="swiper-slide"
      >
       <div class="question-card">
        <div class="question-card_title">{{ item.title }}</div>
        <div class="question-card_tag">{{item.knowledgePoint}}</div>
        <div class="question-card_cnt">
          <img :src="item.questionImg" class="question-card_img" />
        </div>
        <div class="question-card_ft">
          <span>题目难度</span>
          <div class="stars">
            <span
              v-for="star in 5"
              :key="star"
              class="star"
              :class="{ active: star <= item.difficulty }"
            ></span>
          </div>
        </div>
      </div>
      </swiper-slide>

      <!-- 可选：分页器 -->
      <div class="swiper-pagination" slot="pagination"></div>

      <!-- 可选：导航按钮 -->
    </swiper>
    <div class="swiper-button-prev" @click="slidePrev"></div>
    <div class="swiper-button-next" @click="slideNext"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'CardCarousel',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      questionList: [
        {
          title: '丘成桐少年班-第十七套-第12题',
          difficulty: 4,
          knowledgePoint: '组合',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892093_szou3dyeehloyp_ind6qga%3D%3D_2_1770888493_0.png',
        },
        {
          title: '丘成桐少年班-第十九套-第8题',
          difficulty: 4,
          knowledgePoint: '线性代数',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892134_s5tm5ccmq5jk-u0vzgetaq%3D%3D_2_1770888534_0.png',
        },
        {
          title: '丘成桐少年班-第十五套-第8题',
          difficulty: 4,
          knowledgePoint: '分析学',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892137_zt0um526xu1jn8hbdi1f5w%3D%3D_2_1770888537_1.png',
        },
        {
          title: '丘成桐少年班-第八套-第5题',
          difficulty: 4,
          knowledgePoint: '抽象代数',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892141_vom1dfkpjvo6y7_sbdyt_w%3D%3D_2_1770888541_0.png',
        },
        {
          title: '丘成桐少年班-第十套-第1题',
          difficulty: 4,
          knowledgePoint: '数论',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892144_rl6krs1zaak1xkn4gdpqtg%3D%3D_2_1770888544_0.png',
        },
           {
          title: '丘成桐少年班-第二套-第5题',
          difficulty: 3,
          knowledgePoint: '初等代数',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892148_untmobxppslpwkttyg_nda%3D%3D_2_1770888548_1.png',
        },
        {
          title: '丘成桐少年班-第十四套-第4题',
          difficulty: 2,
          knowledgePoint: '线性代数',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892152_6d5g5ojjz30u9sq4rzwvkw%3D%3D_2_1770888552_2.png',
        },
        {
          title: '丘成桐少年班-第十四套-第7题',
          difficulty: 3,
          knowledgePoint: '组合',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892158_a_bzqyib4zjw4qffywhhkw%3D%3D_2_1770888558_1.png',
        },
        {
          title: '丘成桐少年班-第五套-第8题',
          difficulty: 5,
          knowledgePoint: '数论',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892161_wrayxbn7qepua1d8jfozfa%3D%3D_2_1770888561_2.png',
        },
        {
          title: '丘成桐少年班-第十九套-第7题',
          difficulty: 3,
          knowledgePoint: '分析学',
          questionImg: 'https://pandapub.nosdn.127.net/tmp1770892164_ccdu9gospymmfzqgw4znag%3D%3D_2_1770888564_3.png',
        },
      ],
      swiperOptions: {
        // 居中显示
        centeredSlides: true,

        // 同时显示的卡片数
        slidesPerView: 1,
        // 滑块之间的距离
        spaceBetween: 24,

        // 循环模式
        loop: true,

        // 自动播放（可选）
        autoplay: {
          delay: 120000,
          disableOnInteraction: false
        },

        // 分页器（可选）
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // 导航按钮（可选）
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // 鼠标拖拽
        grabCursor: true,

        // 响应式断点
        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    // 手动控制（可选）
    slideTo(index) {
      this.swiper.slideTo(index)
    },
    slideNext() {
      this.swiper.slideNext()
    },
    slidePrev() {
      this.swiper.slidePrev()
    }
  }
}
</script>

<style scoped lang="less">
.card-carousel {
  width: 100%;
  position: relative;
}
/* Swiper 容器 */
.swiper {
  width: 100%;
  padding-bottom: 100px;
  // overflow: visible; /* 重要：让两侧卡片可见 */
}

/* 单个卡片 */
.swiper-slide {
  height: 268px;
}

/* 激活的中间卡片 */
.swiper-slide-active {
  opacity: 1;
  transform: scale(1);
  z-index: 2;
}

/* 导航按钮样式 */
.swiper-button-prev,
.swiper-button-next {
  background-color: white;
  border-radius: 50%;
  width: clamp(40px, 3.125vw, 60px);
  height: clamp(40px, 3.125vw, 60px);
  top: 113px;
}
.swiper-button-prev {
  left: clamp(-84px, -4.375vw, -60px);
}
.swiper-button-next {
  right: clamp(-84px, -4.375vw, -60px);
}
.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: clamp(16px, 1.04vw, 20px);
  color: #4E5969;
  font-weight: bold;
}

/* 分页器样式 */
.swiper-pagination {
  bottom: 10px !important;
}

/deep/ .swiper-pagination-bullet {
  width: clamp(6px, 0.625vw, 12px);
  height: clamp(6px, 0.625vw, 12px);

  background: #D8D8D8;
  opacity: 1;
}

/deep/.swiper-pagination-bullet-active {
  background: #4E5969; /* 根据设计稿调整颜色 */
  // width: 30px;
  // border-radius: 5px;
}
/*******  卡片样式   ********/
.question-card {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url('@/common/images/student/img_ques_card.png') no-repeat center / 100% 100%;
  padding: clamp(10px, 1.04vw, 20px);
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &_title {
    font-size: clamp(14px, 1.04vw, 20px);
    color: #1D2129;
    font-weight: 500;
    margin-bottom: 12px;
    text-align: left;
  }
  &_cnt {
    background: #fff;
    border-radius: 16px;
    margin-bottom: 22px;
    padding: 7px 20px;
    box-sizing: border-box;
    height: 148px;
    display: flex;
    align-items: center;
  }
  &_img {
    max-width: 100%;
    max-height: 100%;
  }
  &_tag {
    position: absolute;
    top: 0;
    right: 0px;
    width: 29.2%;
    font-size: clamp(12px, 0.677vw, 13px);
    line-height: 30px;
    color: #fff;
    text-align: center;
  }
  &_ft {
    display: flex;
    align-items: center;
      span {
      font-size: 11px;
      color: #4E5969;
      font-weight: 500;
    }
  }
  .stars {
    display: flex;
    gap: 4px;
    margin-left: 8px;
    .star {
      width: 16px;
      height: 16px;
      background: url('@/common/images/student/ic_star.png') no-repeat center / contain;
      &.active {
        background-image: url('@/common/images/student/ic_star_fill.png');
      }
    }
  }
}
</style>